import { connect } from 'react-redux'
import { deepCopy } from '../../../lib'

import * as api from '../../../actions/api'
import * as actions from '../../../actions'
import { LiveGame } from '../components'
import * as constants from '../../../constants'
import { getWord, WID } from '../../../constants/Language';

const mapStateToProps = (state, ownProps) => {
  var cards, userType, liveStatus, liveCards, liveId, contributor, json_live_moves, json_current_moves, enableSendButton, enableEndButton, enableRestartButton, enableDeleteButton, isVisibleBoard, isVisibleChat, boardContext, chatMessage, newCard
  var { openConfirmDialog, tabId } = state.liveGame
  var { socket } = state.api.live
  const { language } = state.user
  cards = state.renjuBoardCards.cards
  liveId = ownProps.match.params.id
  userType = ''
  liveStatus = 0
  if (state.liveGame[liveId]) {
    userType = state.liveGame[liveId].userType ? state.liveGame[liveId].userType : ''
    liveStatus = state.liveGame[liveId].liveStatus ? state.liveGame[liveId].liveStatus : 0
    boardContext = state.liveGame[liveId].boardContext ? state.liveGame[liveId].boardContext : null
    chatMessage = state.liveGame[liveId].chatMessage ? state.liveGame[liveId].chatMessage : null
  }

  isVisibleBoard = boardContext && boardContext.isReceived ? boardContext.isReceived : false
  isVisibleChat = chatMessage && chatMessage.isReceived ? chatMessage.isReceived: false

  liveCards = state.renjuBoardCards.cards.filter((card, index) => { return card.live && card.live.liveId === liveId })
  enableSendButton = false
  enableEndButton = false
  enableRestartButton = false
  enableDeleteButton = false
  if (liveCards.length !== 0){
    if (liveCards[0].live.contributor) {
      contributor = liveCards[0].live.contributor
    }
    newCard = deepCopy(liveCards[0])
    newCard = {
      ...newCard,
      moves: deepCopy(newCard.live.moves),
      gameInfo: {
        ...newCard.gameInfo,
        ...newCard.live.gameInfo,
      },
    }
    json_live_moves = JSON.stringify(deepCopy(newCard.live.moves))
    json_current_moves = JSON.stringify(deepCopy(liveCards[0].moves))
    if (userType === constants.userType.CONTRIBUTOR && 
      isVisibleBoard &&
      isVisibleChat &&
      liveStatus === constants.liveStatus.OPEN && (
      json_live_moves !== json_current_moves ||
      liveCards[0].live.gameInfo.title !== liveCards[0].gameInfo.title ||
      liveCards[0].live.gameInfo.blackPlayerName !== liveCards[0].gameInfo.blackPlayerName ||
      liveCards[0].live.gameInfo.whitePlayerName !== liveCards[0].gameInfo.whitePlayerName ||
      liveCards[0].live.gameInfo.gameEndNumber !== liveCards[0].gameInfo.gameEndNumber ||
      liveCards[0].live.gameInfo.gameResult !== liveCards[0].gameInfo.gameResult ))
    {
      enableSendButton = true
    }
  }
  if (userType === constants.userType.CONTRIBUTOR && liveStatus === constants.liveStatus.OPEN) {
    enableEndButton = true
  }
  if (userType === constants.userType.CONTRIBUTOR && liveStatus === constants.liveStatus.CLOSE) {
    enableRestartButton = true
  }
  if (userType === constants.userType.CONTRIBUTOR && liveStatus === constants.liveStatus.CLOSE) {
    enableDeleteButton = true
  }

  var tabProps = []
  tabProps = cards.map((card, index) => {
    if (card.live && card.live.liveId === liveId) {
      if (card.type === constants.boardType.LIVE_GAME) {
        return { bid: index, boardType: card.type, label: 'Live' }
      }
      if (
        card.type === constants.boardType.GAME_ANALYZE && 
        card.analyzeId === 0
      ) {
        return { bid: index, boardType: card.type, label: getWord(WID.LIVE_GAME.TAB.ANALYSIS_BOARD, language), analyzeId: card.analyzeId }
      }
      if (card.type === constants.boardType.GAME_ANALYZE) {
        return { bid: index, boardType: card.type, label: getWord(WID.LIVE_GAME.TAB.ANALYSIS_BOARD, language) + ' ' + card.analyzeId, analyzeId: card.analyzeId }
      }
    }
    return { bid: undefined }
  })
  tabProps = tabProps.filter((props) => props.bid >= 0)

  return ({
    userType,
    tabId,
    tabProps,
    socket,
    liveStatus,
    liveId,
    contributor,
    openConfirmDialog,
    isVisibleBoard,
    isVisibleChat,
    enableSendButton,
    enableEndButton,
    enableRestartButton,
    enableDeleteButton,
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    init: () => {
      if (ownProps.v) {
        dispatch(actions.webBoard.init(constants.boardType.GAME_ANALYZE, {
          v:  ownProps.v,
          md: ownProps.md,
          op: ownProps.op,
          mv: ownProps.mv,
          pb: ownProps.pb,
          pw: ownProps.pw,
          tr: ownProps.tr,
          rc: ownProps.rc,
          an: ownProps.an,
          mc: ownProps.mc,
          mk: ownProps.mk,
          or: ownProps.or,
          sw: ownProps.sw,
          fn: ownProps.fn,
          fm: ownProps.fm,
          tl: ownProps.tl,
          bp: ownProps.bp,
          wp: ownProps.wp,
          gr: ownProps.gr,
        }, ownProps.match.params.id))
        dispatch(actions.liveGame.changeTab(1))
      }
    },
    joinLiveRoom: () => {
      dispatch(api.live.joinLiveRoom(ownProps.match.params.id))
    },
    leaveLiveRoom: () => {
      dispatch(api.live.leaveLiveRoom(ownProps.match.params.id))
    },
    handleClickSendButton: () => {
      dispatch(api.live.updateBoardContext(ownProps.match.params.id))
    },
    handleClickEndButton: (liveId) => () => {
      dispatch(api.live.endLiveGame(liveId))
    },
    handleClickRestartButton: (liveId) => () => {
      dispatch(api.live.restartLiveGame(liveId))
    },
    handleClickDeleteButton: () => {
      dispatch(actions.liveGame.openConfirmDialog())
    },
    handleCloseConfirmDialog: () => {
      dispatch(actions.liveGame.closeConfirmDialog())
    },
    handleOK: (liveId) => () => {
      dispatch(api.live.deleteLiveGame(liveId))
      dispatch(actions.liveGame.closeConfirmDialog())
    },
    handleChangeTab: (tabProps, tabId) => (event, value) => {
      dispatch(actions.liveGame.changeTab(value, tabProps[tabId].bid, tabProps[value].bid))
    },
    handleOpenBoard: (tabProps, tabId) => (analyzeId) => {
      var index
      for (index = 0; index < tabProps.length; index++) {
        if (tabProps[index].analyzeId === analyzeId) {
          dispatch(actions.liveGame.changeTab(index, tabProps[tabId].bid, tabProps[index].bid))
          return
        }
      }
      dispatch(actions.liveGame.changeTab(tabProps.length))
    },
    handleOpenAnalyzeTab: (tabProps, tabId) => () => {
      var index
      for (index = 0; index < tabProps.length; index++) {
        if (tabProps[index].analyzeId === 0) {
          dispatch(actions.liveGame.changeTab(index, tabProps[tabId].bid, tabProps[index].bid))
          return
        }
      }
      dispatch(actions.liveGame.changeTab(tabProps.length))
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LiveGame)


// WEBPACK FOOTER //
// ./src/Pages/Live/containers/LiveGame.js